"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userComponentToDataObject = userComponentToDataObject;
exports.createComponentId = createComponentId;
const sdk_sdtf_core_1 = require("@shapediver/sdk.sdtf-core");
function userComponentToDataObject(o) {
    const additionalProperties = Object.keys(o).filter((prop) => prop === 'additionalProperties');
    const dataObject = (0, sdk_sdtf_core_1.isDataObject)(additionalProperties)
        ? additionalProperties
        : {};
    Object.entries(o)
        .filter(([key, _]) => key !== 'componentId' && key !== 'additionalProperties' && key !== 'data')
        .forEach(([key, value]) => (dataObject[key] = value));
    return dataObject;
}
function createComponentId() {
    return Math.random().toString(36).substring(2, 9);
}
//# sourceMappingURL=SdtfUtils.js.map